<template>
  <div>
    <img src="../../../../assets/images/home/lczy.png" alt="">
  </div>
</template>

<script>
export default {
  name: "guide"
}
</script>

<style scoped>
  h5 {
    padding: 6px 0;
    font-weight: bold;
    font-size: 18px;
  }
  p {
    font-size: 14px;
    text-indent: 2em;
    line-height: 28px;
    margin-bottom: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/views/home/guide/components/guide.vue